/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('LookupsServiceApi', ($http, ApiErrorService) => {
    return {
        getAllActiveLookupGroups: getAllActiveLookupGroups,
        getAllLookupGroups: getAllLookupGroups,
        saveGroup: saveGroup,
        deleteLookupGroup: deleteLookupGroup,
        getAllActiveLookupsByGroupName: getAllActiveLookupsByGroupName,
        getAllActiveLookupsByGroupId: getAllActiveLookupsByGroupId,
        getAllLookupsByGroupId: getAllLookupsByGroupId,
        getAllLookupsByGroupName: getAllLookupsByGroupName,
        saveLookup: saveLookup,
        deleteLookup: deleteLookup
    };
    function getAllActiveLookupGroups() {
        return $http.get(`api/Lookups/GetAllActiveLookupGroups`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllLookupGroups() {
        return $http.get(`api/Lookups/GetAllLookupGroups`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveGroup(lookupgroup) {
        return $http.post(`api/Lookups/SaveGroup`, lookupgroup)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteLookupGroup(groupId) {
        return $http.post(`api/Lookups/DeleteLookupGroup?groupId=${groupId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllActiveLookupsByGroupName(LookupGroupName) {
        return $http.get(`api/Lookups/GetAllActiveLookupsByGroupName?LookupGroupName=${encodeURIComponent(LookupGroupName)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllActiveLookupsByGroupId(LookupGroupId) {
        return $http.get(`api/Lookups/GetAllActiveLookupsByGroupId?LookupGroupId=${LookupGroupId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllLookupsByGroupId(LookupGroupId) {
        return $http.get(`api/Lookups/GetAllLookupsByGroupId?LookupGroupId=${LookupGroupId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllLookupsByGroupName(LookupGroupName) {
        return $http.get(`api/Lookups/GetAllLookupsByGroupName?LookupGroupName=${encodeURIComponent(LookupGroupName)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveLookup(lookup) {
        return $http.post(`api/Lookups/SaveLookup`, lookup)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteLookup(lookupId) {
        return $http.post(`api/Lookups/DeleteLookup?lookupId=${lookupId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
